import React from 'react';
import ClinicianCard from '../../../components/common/ClinicianCard';
import ContactHelpText from '../../../components/common/ContactHelpText';
import DetailRow from '../../../components/common/DetailRow';
import NextSteps from '../../../components/common/NextSteps';
import OutlineButton from '../../../components/common/OutlineButton';
import ResultHero from '../../../components/common/ResultHero';
import { Card, CardBody, SectionTitle } from '../../../components/common/Card';
import { formatAppointmentDateTimeInZone } from '../../../utils/appointmentDisplayUtils';
import { PAYMENT_STATE } from '../../../utils/rescheduleUtils';

const buildNextSteps = (paymentState) => [
  {
    key: 'messages',
    title: 'Check your messages',
    detail:
      'You will receive a new confirmation SMS and email shortly with the updated time.',
  },
  ...(paymentState === PAYMENT_STATE.UNPAID
    ? [
        {
          key: 'pay',
          title: 'Complete your payment',
          detail:
            'The SMS includes your payment link. Your appointment is not secured until it is paid.',
        },
      ]
    : []),
  ...(paymentState === PAYMENT_STATE.MANUAL
    ? [
        {
          key: 'manual',
          title: 'Payment to be arranged',
          detail:
            'Our team will contact you to arrange payment for this appointment.',
        },
      ]
    : []),
  ...(paymentState === PAYMENT_STATE.PAID
    ? [
        {
          key: 'paid',
          title: 'Nothing to pay',
          detail:
            'Your payment carries over to the new time. You will not be charged again.',
        },
      ]
    : []),
];

const RescheduleDone = ({
  workflow,
  contact,
  newStartDateTime,
  timezone,
  durationMinutes,
  paymentState,
  onDone,
}) => (
  <>
    <ResultHero title="Your appointment has been rescheduled" />

    <Card>
      <CardBody>
        <ClinicianCard specialist={workflow?.specialist} />
        <DetailRow
          label="New date and time"
          value={formatAppointmentDateTimeInZone(newStartDateTime, timezone)}
        />
        <DetailRow label="Timezone" value={timezone} />
        <DetailRow
          label="Appointment length"
          value={`${durationMinutes} minutes`}
        />
      </CardBody>
    </Card>

    <Card>
      <CardBody>
        <SectionTitle>What happens next</SectionTitle>
        <NextSteps steps={buildNextSteps(paymentState)} />
      </CardBody>
    </Card>

    <Card>
      <CardBody>
        <OutlineButton block onClick={onDone}>
          Back to my appointment
        </OutlineButton>
      </CardBody>
    </Card>

    <ContactHelpText phone={contact.phone} />
  </>
);

export default RescheduleDone;
